/* eslint-disable no-lone-blocks */
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import { useSnackbar } from "notistack";
import CircularProgress from "@mui/material/CircularProgress";
import Navbar from "../components/Custom/Navbar";
import Customer from "../components/Custom/Customer/Customer";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { getCustomers } from "../services/customers";
import CustomerModal from "../components/Custom/Customer/AddCustomerModal";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const useStyles = makeStyles((theme) => ({
  page: {
    justifyContent: "center",
    padding: "15px",
    position: "absolute",
    bottom: "0px",
    width: "100%",
  },
  root: {
    flexGrow: 1,
    height: "70vh",
    overflow: "hidden",
    width: "100%",
  },
}));

const Header = ({ text, textAlign }) => (
  <MDBox lineHeight={1} textAlign={textAlign || "left"}>
    <MDTypography
      display="block"
      variant="button"
      color="text"
      fontWeight="medium"
    >
      {text}
    </MDTypography>
  </MDBox>
);

function Customers() {
  const classes = useStyles();
  const [page, setPage] = useState(1);
  const [next, setNext] = useState(true);
  const [hasMore, setHasMore] = useState(false);
  const [pages, setPages] = useState(1);
  const [open, setOpen] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [body, setBody] = useState();
  const [loading, setLoading] = useState(true);
  const [customers, setCustomers] = useState([]);
  const [addModal, setaddModal] = useState(false);
  const handleModal = (status) => setaddModal(status);

  const handleChange = async (v) => {
    if (v) {
      setPage(page + 1);
      setNext(true);
    } else {
      setPage(page - 1);
      setNext(false);
    }
  };

  const handleOpen = () => {
    setOpen(true);
  };

  useEffect(() => {
    if (page !== 1) {
      if (next) {
        {
          setBody({
            limit: 10,
            starting_after: customers[customers?.length - 1]?.id,
          });
        }
      } else {
        setBody({ limit: 10, ending_before: customers[0]?.id });
      }
    } else {
      setBody({ limit: 10 });
    }
  }, [page, next]);
  useEffect(() => {
    async function fetchAll() {
      const { customers, hasMore, pages_ } = await getCustomers({
        handleLoading: setLoading,
        enqueueSnackbar: enqueueSnackbar,
        Pages: pages,
        body,
        page: page,
      });
      setCustomers(customers);
      setHasMore(hasMore);
      if (next) setPages(pages_);
    }

    if (body) fetchAll();
  }, [body]);

  return (
    <DashboardLayout>
      <CustomerModal
        open={addModal}
        setOpen={handleModal}
        handleUpdate={() => setBody({ ...body, refresh: true })}
      />
      <Navbar
        text="Manage Customers"
        handleShare={handleOpen}
        handleRefresh={() => setBody({ ...body, refresh: true })}
      >
        <Tooltip title="Add customer">
          <IconButton
            aria-controls="notification-menu"
            variant="contained"
            onClick={() => setaddModal(true)}
          >
            <Icon>add</Icon>
          </IconButton>
        </Tooltip>
        <Tooltip title="Refresh">
          <IconButton
            disableRipple
            color="inherit"
            onClick={() => setBody({ ...body, refresh: true })}
          >
            <Icon>refresh</Icon>
          </IconButton>
        </Tooltip>
      </Navbar>

      <MDBox pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card style={{ minHeight: "80vh" }}>
              <MDBox pt={2}>
                <Grid
                  container
                  justifyContent="space-between"
                  style={{ padding: "0px 10px" }}
                >
                  <Grid item xs={2}>
                    <Header text="Name" />
                  </Grid>
                  <Grid item xs={2}>
                    <Header text="Email" textAlign="center" />
                  </Grid>

                  <Grid item xs={1}>
                    <Header text="Payment method" textAlign="center" />
                  </Grid>
                  <Grid item xs={1}>
                    <Header text="Created At" textAlign="center" />
                  </Grid>

                  <Grid item xs={1} style={{ paddingRight: "18px" }}>
                    <Header text="Actions" textAlign="right" />
                  </Grid>
                </Grid>

                {!loading ? (
                  customers?.length ? (
                    customers?.map((_) => (
                      <Customer
                        user={_}
                        key={_?.id}
                        handleRefresh={() =>
                          setBody({ ...body, refresh: true })
                        }
                      />
                    ))
                  ) : (
                    <div
                      style={{
                        display: "inline",
                        position: "relative",
                        left: "calc(50% - 67px) ",
                        top: "200px",
                      }}
                    >
                      No customer found
                    </div>
                  )
                ) : (
                  <CircularProgress
                    style={{
                      position: "absolute",
                      top: "40%",
                      left: "48%",
                      color: "#3C96EF",
                    }}
                  />
                )}
                <Grid container className={classes.page}>
                  <Grid item>
                    <IconButton
                      onClick={() => handleChange(false)}
                      disabled={page === 1}
                    >
                      <ArrowBackIosIcon />
                    </IconButton>
                  </Grid>
                  <Grid item>
                    <IconButton
                      onClick={(e) => handleChange(true)}
                      disabled={hasMore === false}
                    >
                      <ArrowForwardIosIcon />
                    </IconButton>
                  </Grid>
                </Grid>
                {/* <Pagination
                  className={classes.page}
                  count={pages}
                  page={page}
                  size="small"
                  onChange={handleChange}
                /> */}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default Customers;
